var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form", class: { open: _vm.search } }, [
    _c("img", {
      staticClass: "search",
      attrs: { src: "/images/icons/search.svg", alt: "" }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "close",
      class: { visible: _vm.search, invisible: !_vm.search },
      attrs: { src: "/images/icons/close-search.svg", alt: "" },
      on: {
        click: function($event) {
          _vm.search = ""
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.search,
          expression: "search"
        },
        {
          name: "debounce",
          rawName: "v-debounce:750ms",
          value: _vm.liveSearch,
          expression: "liveSearch",
          arg: "750ms"
        }
      ],
      class: { open: _vm.search },
      attrs: {
        type: "text",
        placeholder:
          "Search Habit Health (eg. Auckland, Physiotherapy, Timetable)"
      },
      domProps: { value: _vm.search },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.enterSearch.apply(null, arguments)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.search = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.search,
            expression: "search"
          }
        ],
        staticClass: "dropdown"
      },
      [
        _vm.results.length
          ? _c(
              "div",
              _vm._l(_vm.results, function(link, key) {
                return _c("a", { key: key, attrs: { href: link.url } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.highlightSearch(link.title)) +
                      "\n      "
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("a", { staticClass: "flex", attrs: { href: _vm.resultsUrl } }, [
          _c("img", {
            attrs: { src: "/images/icons/search-dark.svg", alt: "" }
          }),
          _vm._v(_vm._s(_vm.search))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5450f5e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5450f5e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HomeSearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5450f5e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HomeSearch.vue
// module chunks = 0